var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationSearch = function SvgLocationSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 5.712V3.75a.75.75 0 0 1 1.5 0v1.962A6.09 6.09 0 0 1 17.788 11h1.962a.75.75 0 0 1 0 1.5h-1.962a6.09 6.09 0 0 1-5.288 5.288v1.962a.75.75 0 0 1-1.5 0v-1.962A6.09 6.09 0 0 1 5.712 12.5H3.75a.75.75 0 0 1 0-1.5h1.962A6.09 6.09 0 0 1 11 5.712m.744 1.455a4.583 4.583 0 1 0 .012 0z",
    clipRule: "evenodd"
  })));
};
export default SvgLocationSearch;